import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../../Messages";
import {PaymentMethodDescription} from "../../../../../common/PaymentMethodDescription.jsx";
import {Controller} from "../../../../flows/Controller.js";
import {Router} from "../../../../../../stem-core/src/ui/Router.jsx";
import {PAYMENT_DETAILS_PANEL_URL} from "../../../../PanelConstants.js";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";


class PaymentMethodAcceptOrChangeStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
    };
}

// Component that shows the currently selected payment method or allows you to enter a flow to change/add another
@registerStyle(PaymentMethodAcceptOrChangeStyle)
export class PaymentMethodAcceptOrChange extends UI.Element {
    isValid() {
        return true;
    }

    // TODO @cleanup this should be getPaymentMethod
    getPaymentMethodId(scope, callback) {
        const {selectedPaymentMethod} = Controller.paymentMethod;
        callback(selectedPaymentMethod?.id);
    }

    render() {
        const {selectedPaymentMethod} = Controller.paymentMethod;

        return [
            <PaymentMethodDescription paymentMethod={selectedPaymentMethod}/>,
            <LinkButton onClick={() => Router.changeURL(PAYMENT_DETAILS_PANEL_URL)}>
                {Messages.edit}
            </LinkButton>,
        ]
    }
}
